/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Table_View_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Table view" |
*
* @param {Speakers_Table_View_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_table_view_aria_label = /** @type {((inputs?: Speakers_Table_View_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Table_View_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vue en tableau")
	if (locale === "de") return /** @type {LocalizedString} */ ("Tabellenansicht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Vista tabella")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Табличный вид")
	if (locale === "es") return /** @type {LocalizedString} */ ("Vista de tabla")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("表格视图")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テーブルビュー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेबल दृश्य")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Visualização em tabela")
	return /** @type {LocalizedString} */ ("Table view")
});